import React, { Fragment, useState } from 'react'
import AddButton from '../../components/AddButton'
import AddUsers from './modals/AddUsers'
import Icon from '../../components/Icon'

const styleForIcon = { fontSize: 18, verticalAlign: 1, marginRight: 5 }

const Users = ({ users, usersOfTenant, update, disabled }) => {

  let [isModal, setModal] = useState(false)

  const onCancel = () => setModal(false)
  const onOk = (nextUser) => {
    update({
      users: [
        ...users, ...nextUser.map(user => {
          return usersOfTenant.find(u => u._id === user)
        })],
    })
    onCancel()
  }

  const innerJoin = () => {
    return usersOfTenant.filter(
      ({ _id: idv }) => users.every(({ _id: idc }) => idv !== idc))
  }
  const removeUser = index => {
    update({ users: users.filter((sel, _index) => _index !== index) })
  }
  return (
    <Fragment>
      <div className={'w-100'}>
        <div
          className={'knackly-plain rounded py-1 px-2 border border-dark my-2 minHeight'}
          style={{ width: 400 }}>
          {users.map((user, index) => (
            <div key={'group' + user.name}
                 className="knackly-back-light rounded py-1 px-2 border d-flex justify-content-between my-1">
              <div><Icon type={Icon.fromUser(user)}
                         style={styleForIcon}/>{user.name
                ? user.name
                : user.mail}</div>
              {!disabled && <div onClick={() => removeUser(index)}><Icon
                type="icon-times-pro" className={'timesBtn'} style={{
                width: '1rem',
                height: '1rem',
                verticalAlign: 2,
              }}/></div>}
            </div>),
          )}
        </div>
        {!disabled && <AddButton id={'addUserForGroups'} label={'Add users'}
                                 onClick={() => setModal(true)}/>}

      </div>

      <AddUsers active={isModal} onCancel={onCancel} onOk={onOk}
                users={innerJoin() || usersOfTenant}/>
    </Fragment>
  )
}

export default Users
